import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'

import DatePick from 'vue-date-pick'

export default {
    name: 'CustomerRegister',
    created,
    data,
    methods,
    components: {
        DatePick
    }
}